// extracted by mini-css-extract-plugin
module.exports = {"work":"Work_work__24dVJ","title_open":"Work_title_open__3moMN","title_close":"Work_title_close__2W8Dj","landIn":"Work_landIn__sVA3e"};